import { useCallback, useContext, useRef, useState } from "react";
import { flushSync } from "react-dom";
import { POPUP_STATUS } from "constants/constants";
import { DELIVERY_NOTE_PAGE_SELECTOR } from "constants/forms";
import { DELIVERY_NOTE_PDF_ERROR } from "constants/popup-codes";
import InfoContext from "pages/InfoContext";
import { createPdfFromHtml, waitForNextPaint } from "utils/logic";
import { buildDeliveryNotePdfFileName } from "utils/deliveryNoteHelper";

const A4_CONTENT_WIDTH = 595;
const A4_PAGE_MARGINS = [0, 0, 0, 0];
const RENDER_SCALE = 3;

const useDeliveryNotePdfExport = () => {
  const { setCode, setStatus } = useContext(InfoContext);
  const [isExporting, setIsExporting] = useState(false);
  const exportRef = useRef(null);

  const exportPdf = useCallback(
    async ({ template, number }) => {
      flushSync(() => setIsExporting(true));
      try {
        await waitForNextPaint();
        await createPdfFromHtml({
          fileName: buildDeliveryNotePdfFileName({ template, number }),
          element: Array.from(
            exportRef.current?.querySelectorAll(DELIVERY_NOTE_PAGE_SELECTOR) ||
              []
          ),
          contentWidth: A4_CONTENT_WIDTH,
          pageMargins: A4_PAGE_MARGINS,
          scale: RENDER_SCALE,
        });
      } catch (e) {
        console.error("exportDeliveryNotePdf", e);
        setStatus(POPUP_STATUS.ERROR);
        setCode(DELIVERY_NOTE_PDF_ERROR);
      } finally {
        flushSync(() => setIsExporting(false));
      }
    },
    [setCode, setStatus]
  );

  return { isExporting, exportRef, exportPdf };
};

export default useDeliveryNotePdfExport;
